"use client";

import { useTranslations } from "next-intl";

import type messages from "@/messages/en-US.json";

type ValidationKey = `validation.${keyof (typeof messages)["validation"]}`;

/**
 * Field errors are catalog keys ("validation.email"), set by the Zod schemas so the
 * same rule reads right in both languages. Anything else (e.g. a backend message)
 * shows the generic "check this value".
 */
export function useFieldMessage(): (message: string | undefined) => string | undefined {
  const t = useTranslations();
  return (message) => {
    if (!message) return undefined;
    return message.startsWith("validation.") && t.has(message as ValidationKey)
      ? t(message as ValidationKey)
      : t("validation.invalid");
  };
}
